import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import Modal from '../../../../../../../components/Modal';
import RichTextBox from '../../../../../../../components/RichTextBox';
import { useCreateTeacherDocumentMutation } from '../../../../../../../features/authentication/teacherDocumentApiSlice';
import CustomToast from '../../../../../../../components/Toast';
import { useCreateResourceSetMutation } from '../../../../../../../features/authentication/qSetApiSlice';
import ActivityTypes from '../../../../../../../enums/activityTypes';
import { useNavigate } from 'react-router';
import NewResourceSetNameModal from './newResourceSetNameModal';

const AddDocumentModal = ({
  showModal,
  setShowModal,
  setId,
  onDocumentAdded,
}) => {
  const [documentContent, setDocumentContent] = useState('');
  const [documentTitle, setDocumentTitle] = useState('');
  const [createTeacherDocument, { isLoading: documentIsLoading }] =
    useCreateTeacherDocumentMutation();
  const [createResourceSet, { isLoading: resourceIsLoading }] =
    useCreateResourceSetMutation();
  const [showNewSetNameModal, setShowNewSetNameModal] = useState(false);
  const [newSetName, setNewSetName] = useState(documentTitle);
  const navigate = useNavigate();

  useEffect(() => {
    setDocumentTitle('');
    setDocumentContent('');
  }, [showModal]);

  const handleAddDocument = async (isNewSet) => {
    try {
      const result = await createTeacherDocument({
        description: documentTitle,
        isURL: false,
        document: documentContent,
        scope: 0,
        setId: setId,
      });

      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Url || result.error.data.errors.Description, 'error');
        else 
          CustomToast(result.error.data.error, 'error');

      } else {
        CustomToast('Resource Created Successfully.', 'success');
        setShowModal(false);
        if (isNewSet) {
          navigate(`${setId}`);
        } else if (onDocumentAdded) {
          onDocumentAdded();
        }
      }
    } catch (error) {
      CustomToast('Failed To Create Resource.', 'error');
      console.log(error);
    }
  };

  const handleCreateNewResourceSet = async (e) => {
    e.preventDefault();

    const option = {
      description: newSetName,
      activityType: ActivityTypes.Documents,
    };

    try {
      const result = await createResourceSet(option);
      if (result.error) {
        if (result.error.data.errors) {
          CustomToast(result.error.data.errors.Description, 'error');
        } else {
          CustomToast(result.error.data.error, 'error');
        }
      } else {
        setId = result.data;
        handleAddDocument(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTitleValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length > 50) {
      event.target.setCustomValidity('Title must not exceed 50 characters!');
    } else {
      event.target.setCustomValidity('');
    }
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        titleName='Add Document'
        contentWidth='50%'>
        <Form className='d-flex flex-column' onSubmit={(e) => { e.preventDefault(); setId > 0 ? handleAddDocument(false) : setShowNewSetNameModal(true) }}>
          <Form.Group id='title' className='w-100'>
            <Form.Label>Title</Form.Label>
            <Form.Control disabled={documentIsLoading || resourceIsLoading} type='text' className='w-100' required defaultValue={documentTitle} onInput={handleTitleValidation} onChange={(e) => setDocumentTitle(e.target.value)} />
          </Form.Group>

          <div className='mb-3 mt-5'>Resource</div>
          <RichTextBox content={documentContent} setContent={setDocumentContent} disabled={documentIsLoading || resourceIsLoading} />

          <div className='d-flex flex-row justify-content-end gap-2 mt-3'>
            <Button style={{ minWidth: '90px' }} variant='castleGray' onClick={() => setShowModal(false)}>Cancel</Button>
            <Button disabled={documentIsLoading || resourceIsLoading} style={{ minWidth: '90px' }} variant='castleRed' type='submit'>{documentIsLoading || resourceIsLoading ? 'Saving...' : 'Save'}</Button>
          </div>
        </Form>
      </Modal>

      <NewResourceSetNameModal
        showModal={showNewSetNameModal}
        setShowModal={setShowNewSetNameModal}
        newSetName={newSetName}
        setNewSetName={setNewSetName}
        handleCreateNewResourceSet={handleCreateNewResourceSet}
      />
    </>
  );
};

AddDocumentModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  handleSave: PropTypes.func,
};

export default AddDocumentModal;
